/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  removeAnalyst,
  retrieveAnalysts,
  saveAnalystFailure,
  saveAnalystSuccess,
} from '@store/scenario/analyst/analyst-slice';

export const removeAnalystEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(removeAnalyst.type),
  concatMap((action: PayloadAction<number>) => from(dependencies.analystGateway.remove(action.payload)).pipe(
    concatMap(() => of(saveAnalystSuccess(), retrieveAnalysts())),
    catchError(() => of(saveAnalystFailure('Failed to remove analyst'))),
  )),
);
